module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-right.65b1787d.svg";